// Mock data for ViralVantage Media

export const portfolioVideos = [
  {
    id: 1,
    title: "Luxury Property Showcase",
    category: "Real Estate",
    thumbnail: "https://images.unsplash.com/photo-1512917774080-9991f1c4c750?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjByZWFsJTIwZXN0YXRlfGVufDB8fHx8MTc3MDQxMTMyNHww&ixlib=rb-4.1.0&q=85",
    videoUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ",
    views: "2.4M",
    engagement: "95%"
  },
  {
    id: 2,
    title: "Modern Villa Tour",
    category: "Real Estate",
    thumbnail: "https://images.unsplash.com/photo-1613490493576-7fde63acd811?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjByZWFsJTIwZXN0YXRlfGVufDB8fHx8MTc3MDQxMTMyNHww&ixlib=rb-4.1.0&q=85",
    videoUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ",
    views: "1.8M",
    engagement: "92%"
  },
  {
    id: 3,
    title: "Waterfront Estate",
    category: "Real Estate",
    thumbnail: "https://images.unsplash.com/photo-1531971589569-0d9370cbe1e5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjByZWFsJTIwZXN0YXRlfGVufDB8fHx8MTc3MDQxMTMyNHww&ixlib=rb-4.1.0&q=85",
    videoUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ",
    views: "3.1M",
    engagement: "97%"
  },
  {
    id: 4,
    title: "Transform in 30 Days",
    category: "Fitness",
    thumbnail: "https://images.unsplash.com/photo-1595078475328-1ab05d0a6a0e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHwxfHxmaXRuZXNzJTIwd29ya291dHxlbnwwfHx8fDE3NzA0MTEzMjl8MA&ixlib=rb-4.1.0&q=85",
    videoUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ",
    views: "5.2M",
    engagement: "98%"
  },
  {
    id: 5,
    title: "HIIT Workout Challenge",
    category: "Fitness",
    thumbnail: "https://images.unsplash.com/photo-1634788699201-77bbb9428ab6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHwyfHxmaXRuZXNzJTIwd29ya291dHxlbnwwfHx8fDE3NzA0MTEzMjl8MA&ixlib=rb-4.1.0&q=85",
    videoUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ",
    views: "4.7M",
    engagement: "96%"
  },
  {
    id: 6,
    title: "Strength Training Series",
    category: "Fitness",
    thumbnail: "https://images.unsplash.com/photo-1518310383802-640c2de311b2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHwzfHxmaXRuZXNzJTIwd29ya291dHxlbnwwfHx8fDE3NzA0MTEzMjl8MA&ixlib=rb-4.1.0&q=85",
    videoUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ",
    views: "3.9M",
    engagement: "94%"
  },
  {
    id: 7,
    title: "Scale Your Consulting Business",
    category: "Business",
    thumbnail: "https://images.unsplash.com/photo-1507679799987-c73779587ccf?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwxfHxidXNpbmVzcyUyMHByb2Zlc3Npb25hbHxlbnwwfHx8fDE3NzA0MTEzMzZ8MA&ixlib=rb-4.1.0&q=85",
    videoUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ",
    views: "2.8M",
    engagement: "93%"
  },
  {
    id: 8,
    title: "Leadership Mastery",
    category: "Business",
    thumbnail: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwyfHxidXNpbmVzcyUyMHByb2Zlc3Npb25hbHxlbnwwfHx8fDE3NzA0MTEzMzZ8MA&ixlib=rb-4.1.0&q=85",
    videoUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ",
    views: "3.5M",
    engagement: "95%"
  },
  {
    id: 9,
    title: "Executive Coaching Series",
    category: "Business",
    thumbnail: "https://images.unsplash.com/photo-1560250097-0b93528c311a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwzfHxidXNpbmVzcyUyMHByb2Zlc3Npb25hbHxlbnwwfHx8fDE3NzA0MTEzMzZ8MA&ixlib=rb-4.1.0&q=85",
    videoUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ",
    views: "2.1M",
    engagement: "91%"
  }
];

export const pricingPlans = [
  {
    id: 1,
    name: "Starter",
    price: 499,
    videosPerMonth: 5,
    features: [
      "5 Viral Videos/Month",
      "24-48 Hour Turnaround",
      "1 Revision Per Video",
      "Retention-Optimized Editing",
      "Hook & CTA Templates",
      "Basic Analytics Report"
    ],
    recommended: false
  },
  {
    id: 2,
    name: "Growth",
    price: 1299,
    videosPerMonth: 15,
    features: [
      "15 Viral Videos/Month",
      "24-48 Hour Turnaround",
      "2 Revisions Per Video",
      "Retention-Optimized Editing",
      "Custom Hook & CTA Design",
      "Advanced Analytics Dashboard",
      "Dedicated Account Manager",
      "Priority Support"
    ],
    recommended: true
  },
  {
    id: 3,
    name: "Authority",
    price: 2499,
    videosPerMonth: 30,
    features: [
      "30 Viral Videos/Month",
      "12-24 Hour Turnaround",
      "Unlimited Revisions",
      "Retention-Optimized Editing",
      "Custom Hook & CTA Design",
      "Premium Analytics & Insights",
      "Dedicated Senior Editor",
      "24/7 Priority Support",
      "Strategy Consultation Call",
      "Content Calendar Planning"
    ],
    recommended: false
  }
];

export const faqs = [
  {
    id: 1,
    question: "What's your typical turnaround time?",
    answer: "Our standard turnaround is 24-48 hours for most packages. Authority plan members enjoy expedited 12-24 hour delivery. Rush orders can be accommodated for an additional fee."
  },
  {
    id: 2,
    question: "How does your revision policy work?",
    answer: "Starter plan includes 1 revision per video, Growth includes 2 revisions, and Authority offers unlimited revisions. We want you to be 100% satisfied with every video we produce."
  },
  {
    id: 3,
    question: "Why should I outsource instead of hiring in-house?",
    answer: "Hiring an in-house editor costs $50K-$80K annually plus benefits, equipment, and software. With ViralVantage, you get expert-level editing at a fraction of the cost, with no management overhead, and the flexibility to scale up or down as needed."
  },
  {
    id: 4,
    question: "What makes your editing 'retention-optimized'?",
    answer: "We use data-driven techniques including strategic hook placement, pacing adjustments, pattern interrupts, visual effects timing, and psychological triggers that keep viewers engaged from start to finish. Our videos consistently achieve 90%+ retention rates."
  },
  {
    id: 5,
    question: "What video formats do you accept?",
    answer: "We accept all major video formats including MP4, MOV, AVI, and more. Simply upload your raw footage through our secure portal, and we'll handle the rest."
  },
  {
    id: 6,
    question: "Can you edit for multiple platforms?",
    answer: "Absolutely! We optimize videos for Instagram Reels, TikTok, YouTube Shorts, Facebook Reels, and LinkedIn. Each platform gets custom formatting and optimization."
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Marcus Chen",
    title: "Real Estate Broker",
    company: "Luxury Estates LA",
    text: "ViralVantage transformed my content strategy. My property videos now consistently hit 1M+ views, and I've closed 3 high-ticket deals directly from viral content. Best investment I've made.",
    rating: 5
  },
  {
    id: 2,
    name: "Sarah Williams",
    title: "Fitness Coach",
    company: "FitLife Coaching",
    text: "I went from 10K to 250K followers in 6 months thanks to their retention-optimized editing. The engagement on my Reels is insane. I save 20+ hours weekly and my business has 5X'd.",
    rating: 5
  },
  {
    id: 3,
    name: "David Rodriguez",
    title: "Business Consultant",
    company: "Scale Masters",
    text: "These guys understand virality at a scientific level. Every video they produce drives leads. I'm booking $10K consulting calls directly from my short-form content. Game changer.",
    rating: 5
  }
];

export const workflowSteps = [
  {
    id: 1,
    number: "01",
    title: "Upload Raw Footage",
    description: "Send us your raw clips through our secure portal. No editing required on your end - we'll handle everything from start to finish."
  },
  {
    id: 2,
    number: "02",
    title: "We Apply Viral Patterns",
    description: "Our expert editors use proven retention techniques, hooks, transitions, and effects to engineer your content for maximum engagement."
  },
  {
    id: 3,
    number: "03",
    title: "You Post & Scale",
    description: "Receive your polished, platform-optimized videos ready to upload. Watch your engagement soar and your business grow exponentially."
  }
];

export const stats = [
  {
    id: 1,
    value: "500M+",
    label: "Total Views Generated"
  },
  {
    id: 2,
    value: "95%",
    label: "Average Retention Rate"
  },
  {
    id: 3,
    value: "2000+",
    label: "Videos Delivered"
  },
  {
    id: 4,
    value: "24-48hr",
    label: "Average Turnaround"
  }
];
